export default __webpack_public_path__ + "static/media/dark-dash.05effcb0.png";